import {
  ClientDTO,
  Currency,
  FilterDTO,
  FilterOperator,
  ParkerCompanyClient,
  ParkerCompanyDTO,
  ParkerDTO,
  ParkerGroup,
  ParkerSubscriptionAssignmentDTO,
  ParkerTagDTO,
  SortDirection,
  LimitedUserInfoDTO,
  ParkerRegistrationClient,
  ParkingPermitDTO,
  PrintableParkingPermitDTO,
} from '../../../../base/models/models.swagger.generated';
import { Observable, of } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';
import { CountryISO2 } from '../../../../base/shared/countryISO2-enum';
import { AutocompleteItem } from '../../../../base/shared/autocomplete/autocomplete-item';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { EditParkerFormGroup } from './edit-parker-form.type';
import { NgIf } from '@angular/common';
import { EditParkerSubscriptionListComponent } from './edit-parker-subscription-list/edit-parker-subscription-list.component';
import { EditParkerTagsListComponent } from './edit-parker-tags-list/edit-parker-tags-list.component';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { ButtonGroupComponent } from '../../../../base/shared/button-group/button-group.component';
import { YesNoGroupButtonComponent } from '../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { AutocompleteComponent } from '../../../../base/shared/autocomplete/autocomplete.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { EnumDropDownListComponent } from '../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';
import { AppErrorMessagesComponent } from '../../../../base/error-messages/app-error-messages.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthService } from 'src/app/base/services/auth.service';

@Component({
  selector: 'app-edit-parker-form',
  templateUrl: './edit-parker-form.component.html',
  styleUrls: ['./edit-parker-form.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    AppErrorMessagesComponent,
    EnumDropDownListComponent,
    DatePickerModule,
    DropDownListModule,
    AutocompleteComponent,
    YesNoGroupButtonComponent,
    ButtonGroupComponent,
    AccordionModule,
    EditParkerTagsListComponent,
    EditParkerSubscriptionListComponent,
    NgIf,
    TranslateModule,
  ],
})
export class EditParkerFormComponent implements OnInit {

  @Input() public parkerEditForm: EditParkerFormGroup;
  @Input() public client: ClientDTO;
  @Input() public rowData: any;


  public get isAdd(): boolean {
    return !this.parkerEditForm.value.id;
  }

  public get selectedCountry(): string {
    return this.parkerEditForm.controls.country.value;
  }

  public set selectedCountry(value: string) {
    this.parkerEditForm.controls.country.setValue(value);
  }

  public get selectedPrivateCountry(): string {
    return this.parkerEditForm.controls.privateCountry.value;
  }

  public set selectedPrivateCountry(value: string) {
    this.parkerEditForm.controls.privateCountry.setValue(value);
  }

  public get parkerTags(): ParkerTagDTO[] {
    return this.parkerEditForm.controls.tags.value;
  }

  public set parkerTags(tags: ParkerTagDTO[]) {
    this.parkerEditForm.controls.tags.setValue(tags);
  }

  public get parkerSubscriptions(): ParkerSubscriptionAssignmentDTO[] {
    return this.parkerEditForm.controls.parkerSubscriptionAssignments.value;
  }

  public set parkerSubscriptions(subscriptionAssignments: ParkerSubscriptionAssignmentDTO[]) {
    this.parkerEditForm.controls.parkerSubscriptionAssignments.setValue(subscriptionAssignments);
  }

  public ParkerGroup = ParkerGroup;
  public CurrencyEnum = Currency;
  public countries: AutocompleteItem[] = [];
  public parker: ParkerDTO;
  public companies: ParkerCompanyDTO[] = [];
  public dropdownSettings = { text: 'name', value: 'id' };

  constructor(private parkerCompanyClient: ParkerCompanyClient,
    private parkerRegistrationClient: ParkerRegistrationClient,
    private translate: TranslateService,
    private authService: AuthService) {
  }

  public ngOnInit(): void {
    // eslint-disable-next-line guard-for-in
    for (const country in CountryISO2) {
      this.countries.push({
        id: this.translate.instant('i18n.shared.CountryISO2.' + country),
        name: this.translate.instant('i18n.shared.CountryISO2.' + country),
      });
    }
    const loggedInUser = this.authService.getUserInfo();
    if (this.authService.isUserCompanyAdmin()) {
      this.companies = [loggedInUser.company];
      this.parkerEditForm.controls.companyId.setValue(loggedInUser.companyId);
      // disable company selection
      this.parkerEditForm.controls.companyId.disable();
    }
    else {
      const filters = [];
      filters.push(new FilterDTO({ isComplex: false, field: 'Active', operator: FilterOperator.Equal, value: 'true' }));
      this.parkerCompanyClient.searchParkerCompanies(this.client.id, filters, 0, 0, 'Id', SortDirection.Ascending)
        .subscribe(companies => {
          this.companies = companies.items;
        });
        this.parkerEditForm.controls.companyId.enable();
    }
  }

  public getCountries(searchText: string): Observable<AutocompleteItem[]> {
    return of(this.countries.filter(country => country.name.toLowerCase().includes(searchText?.toLowerCase())));
  }

  public renewParkingPermitGuid(): void {
    this.parkerRegistrationClient.renewParkingPermit(this.rowData.id)
      .subscribe((parkingPermit: ParkingPermitDTO) => {
        this.parkerEditForm.controls.activeParkingPermitGuid.setValue(parkingPermit.permitGuid)});
  }

  public printParkingPermit(): void {
    this.parkerRegistrationClient.getPrintableParkingPermit(this.rowData.id)
      .subscribe((printableParkingPermit: PrintableParkingPermitDTO) => {
      const link = this.createInvisibleDownloadLink(printableParkingPermit);
      link.click();
      });
  }

  private createInvisibleDownloadLink(permitDTO: PrintableParkingPermitDTO) {
    const source = `data:application/octet-stream;base64,${permitDTO.base64FileContent}`;
    const link = document.createElement('a');
    link.href = source;
    link.download = `${permitDTO.filename}`;
    return link;
  }
}
